export const REQUESTS_LOADING = 'requestsTable/REQUESTS_LOADING';
export const REQUESTS_DONE = 'requestsTable/REQUESTS_DONE';
export const REQUESTS_ERROR = 'requestsTable/REQUESTS_ERROR';
export const CHANGE_PAGE = 'requestsTable/CHANGE_PAGE';
export const CHANGE_PER_PAGE = 'requestsTable/CHANGE_PER_PAGE';
export const CHANGE_SORT = 'requestsTable/CHANGE_SORT';
export const SET_FILTER = 'requestsTable/SET_FILTER';
export const SET_START_DATE = 'requestsTable/SET_START_DATE';
export const SET_FINAL_DATE = 'requestsTable/SET_FINAL_DATE';
export const RESET_REQUESTS = 'requestsTable/RESET_REQUESTS';